var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import iconCSS from "@/components/asset/uf-icon/icon.css";
let IconAdd = class IconAdd extends LitElement {
    render() {
        return html `
      <svg viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9.5" cy="10" r="9.5" />
        <rect width="10.8571" height="1.80953" rx="0.904765" transform="matrix(-5.27618e-07 -1 1 4.83907e-07 8.59521 15.4286)"
          fill="#FF284F" />
        <rect width="10.8571" height="1.80952" rx="0.90476"
          transform="matrix(-1 -3.99613e-07 -6.11911e-07 -1 14.9286 10.9048)" fill="#FF284F" />
      </svg>
    `;
    }
};
IconAdd.styles = [iconCSS, css `
    circle {
      fill: var(--color);
    }
    rect {
      fill: var(--color-primary);
    }
  `];
IconAdd = __decorate([
    customElement("icon-add")
], IconAdd);
export { IconAdd };
